<template>
  <div v-if="hasRounds" class="knockout-standings">
    <div class="knockout-tabs">
      <button
        v-for="(item, i) in rounds"
        :key="i"
        type="button"
        class="knockout-tab"
        :class="{ 'knockout-tab--active': i === current }"
        @click="changeRound(i)"
      >
        <span v-if="item.alias">{{ item.alias }}</span>
        <span v-else>第{{ i + 1 }}轮</span>
      </button>
    </div>
    <div class="knockout-games">
      <template v-if="currentGames.length">
        <Game
          v-for="(g, idx) in currentGamesMapped"
          :key="g.id != null ? g.id : `game-${idx}`"
          :game="g"
        />
      </template>
      <van-empty v-else description="本轮暂无比赛" />
    </div>
  </div>
  <van-empty v-else description="暂无淘汰赛数据" />
</template>

<script>
import Game from './game.vue'

function normalizeScore(v) {
  if (v === -1) return ''
  return v
}

/** 淘汰赛接口可能为嵌套 homeTeam/awayTeam，或与赛程一致的扁平字段 */
function mapKnockoutGameToGameProp(item, roundAlias) {
  if (!item || typeof item !== 'object') {
    return {}
  }
  const nested = item.homeTeam && typeof item.homeTeam === 'object'
  let homeTeamId
  let awayTeamId
  let homeName
  let awayName
  let homeBadge
  let awayBadge
  if (nested) {
    const h = item.homeTeam || {}
    const a = item.awayTeam || {}
    homeTeamId = h.id
    awayTeamId = a.id
    homeName = h.alias || h.name || ''
    awayName = a.alias || a.name || ''
    homeBadge = h.badge
    awayBadge = a.badge
  } else {
    homeTeamId = item.homeTeamId
    awayTeamId = item.awayTeamId
    homeName = item.homeAlias || item.homeName || ''
    awayName = item.awayAlias || item.awayName || ''
    homeBadge = item.homeBadge
    awayBadge = item.awayBadge
  }
  const roundName =
    (item.roundName && String(item.roundName).trim()) ||
    (roundAlias && String(roundAlias).trim()) ||
    ''
  return {
    id: item.id,
    liveStatus: item.liveStatus,
    gameStatus: item.gameStatus,
    homeTeamId,
    awayTeamId,
    homeName,
    awayName,
    homeBadge,
    awayBadge,
    homeScore: normalizeScore(item.homeScore),
    awayScore: normalizeScore(item.awayScore),
    beginDate: item.beginDate,
    roundName,
    fieldName: item.fieldName,
    courtName: item.courtName,
    location: item.location,
    gameCourtName: item.gameCourtName,
    groupName: item.group || '',
    name: item.name || ''
  }
}

export default {
  name: 'KnockoutStandings',
  components: { Game },
  props: {
    rounds: {
      type: Array,
      default() {
        return []
      }
    }
  },
  data() {
    return {
      current: 0
    }
  },
  computed: {
    hasRounds() {
      return Array.isArray(this.rounds) && this.rounds.length > 0
    },
    currentRound() {
      if (!this.hasRounds) return null
      return this.rounds[this.current] || null
    },
    currentGames() {
      const r = this.currentRound
      if (!r || !Array.isArray(r.games)) return []
      return r.games
    },
    currentGamesMapped() {
      const alias = this.currentRound && this.currentRound.alias
      const list = [...this.currentGames]
      list.sort((a, b) => {
        const ta = new Date(a && a.beginDate ? a.beginDate : 0).getTime()
        const tb = new Date(b && b.beginDate ? b.beginDate : 0).getTime()
        return ta - tb
      })
      return list.map(g => mapKnockoutGameToGameProp(g, alias))
    }
  },
  watch: {
    rounds: {
      handler(val) {
        if (!Array.isArray(val) || val.length === 0) {
          this.current = 0
          return
        }
        if (this.current >= val.length) {
          this.current = 0
        }
      },
      immediate: true
    }
  },
  methods: {
    changeRound(i) {
      this.current = i
    }
  }
}
</script>

<style scoped lang="scss">
.knockout-standings {
  margin-top: 4px;
}

.knockout-tabs {
  display: flex;
  flex-wrap: wrap;
  margin-right: -8px;
  margin-bottom: 4px;
}

.knockout-tab {
  flex: 1;
  min-width: 0;
  margin-right: 8px;
  margin-bottom: 8px;
  padding: 8px 10px;
  border: none;
  border-radius: 4px;
  font-size: 14px;
  line-height: 1.2;
  background: #ecf5ff;
  color: #337ecc;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;

  &--active {
    background: #337ecc;
    color: #fff;
    font-weight: 500;
  }
}

.knockout-games {
  background: transparent;
}

/**
 * Game 卡片默认 min-height: 110px，用于有标题栏+比分时的版心。
 * 淘汰赛接口常无 alias（卡片无 roundName）、无比分/状态时内容较矮，
 * 仍套 110px 会在卡片底部出现大块空区；赛程数据更「满」故不易察觉。
 */
// .knockout-games ::v-deep .game-container {
//   min-height: 0;
// }

// .knockout-games ::v-deep .game-container:first-of-type {
//   margin-top: 0;
// }
</style>
